import React from 'react'
import { history } from '../store'
import ContractTimeZoneSelect from './ContractTimeZoneSelect'
import '../styles/QRsAdminView.css'

class ContractActiveList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filterOpen: true,
      filters: {
        customer: '',
        serial: '',
      },
    };
    this.toggleFilter = this.toggleFilter.bind(this)
  }

  goTo(number, e) {
    history.push(`/contracts/${number}`)
  }

  toggleFilter() {
    this.setState(prev => ({ filterOpen: !prev.filterOpen }))
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  render() {
    const { filters, filterOpen } = this.state;
    const { contracts } = this.props;

    const filteredContractActive = contracts.filter(contract => {
      const { customer: customerFilter, serial: serialFilter } = filters;
      if (customerFilter && (!contract.Customer || !contract.Customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))) return false;
      if (serialFilter && (!contract.Machine || !contract.Machine.Serial.toLowerCase().includes(serialFilter.toLowerCase()))) return false;
      return contract.Status !== 'TERMINATED';
    });

    return (
      <div>
        {/* Collapsible Filter Panel */}
        <div className="qrs-admin-filter-card">
          <div className="qrs-admin-filter-header" onClick={this.toggleFilter}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
          </div>
          {filterOpen && (
            <div className="qrs-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label>Máquina</label>
                  <input
                    type="text"
                    placeholder="Buscar por serial..."
                    value={filters.serial}
                    onChange={e => this.handleFilterChange('serial', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label>Cliente</label>
                  <input
                    type="text"
                    placeholder="Buscar por cliente..."
                    value={filters.customer}
                    onChange={e => this.handleFilterChange('customer', e.target.value)}
                  />
                </div>
                <div className="filter-group filter-actions">
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <button type="button" className="btn btn-light" onClick={() => this.setState({ filters: { customer: '', serial: '' } })}>Limpiar</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Column Headers */}
        <div className="qrs-admin-list-header">
          <div className="qrs-header-col col-id">Máquina</div>
          <div className="qrs-header-col col-customer">Cliente</div>
          <div className="qrs-header-col col-payments">Fecha inicio</div>
          <div className="qrs-header-col col-payments">Fecha fin</div>
          <div className="qrs-header-col col-zone">Zona horaria</div>
          <div className="qrs-header-col col-status">Estado</div>
        </div>

        {/* Cards */}
        <div className="qrs-admin-list">
          {filteredContractActive.length > 0 ? (
            filteredContractActive
              .sort((a, b) => a.Machine.Serial.localeCompare(b.Machine.Serial))
              .map(contract => (
                <div key={contract.number} className="qrs-admin-card" onClick={e => this.goTo(contract.number, e)}>
                  <div className="qrs-admin-row">
                    <div className={`qrs-admin-status-bar ${contract.Status}`}></div>
                    <div className="qrs-admin-content">
                      <div className="qrs-admin-machine-id">
                        <div className="qrs-admin-code">{contract.Machine.Serial}</div>
                      </div>
                      <div className="qrs-admin-machine-customer">
                        <div className="qrs-admin-customer-name">{contract.Customer.Fullname}</div>
                      </div>
                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-sub">{new Date(contract.StartDate).toDateString()}</div>
                      </div>
                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-sub">{new Date(contract.EndDate).toDateString()}</div>
                      </div>
                      <div className="qrs-admin-machine-zone">
                        <ContractTimeZoneSelect contract={contract} />
                      </div>
                      <div className="qrs-admin-machine-status">
                        <div className="qrs-admin-sub">{contract.Status}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <div className="qrs-admin-empty">
              <i className="fas fa-file-contract"></i>
              <p>No se encontraron contratos activos</p>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default ContractActiveList

